import { LocalizedText, usePromiseState } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { WithAvailabilityBlockId } from '@mews-commander/types';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { EditDialogForm } from '@mews-commander/legacy-form';
import { releaseAll } from '../../actions/formActions';
import { useAvailabilityBlock } from '../../utils/useAvailabilityBlock';

interface ReleaseAllDialogProps extends WithAvailabilityBlockId {
    onClose: () => void;
}

export const ReleaseAllDialog: React.FC<ReleaseAllDialogProps> = ({ onClose, availabilityBlockId }) => {
    const dispatch = useCommanderThunkDispatch();
    const availabilityBlock = useAvailabilityBlock(availabilityBlockId);

    const [submitting, handleSubmit] = usePromiseState();

    if (!availabilityBlock) {
        return null;
    }

    const submit = async () => {
        await (dispatch(releaseAll(availabilityBlockId, availabilityBlock.serviceId)) as unknown as Promise<void>);
        onClose();
    };

    return (
        <EditDialogForm
            active
            handleSubmit={handleSubmit(submit)}
            closeDialog={onClose}
            loading={submitting}
            primaryButtonTextKey={TextKey.ReleaseAll}
            primaryButtonVariant="destructive"
            title={<LocalizedText textKey={TextKey.ReleaseAll} />}
        >
            <LocalizedText textKey={TextKey.ReleaseBlockDialogMessage} />
        </EditDialogForm>
    );
};
